const namespace = '[ENTITY_TRIPS]';

export const SET_TRIPS = `${namespace} SET_TRIPS`;
